
import ReactDOM from "react-dom";
import React, { useEffect, useState } from "react";
import {AppLink as Link, AppWrapper} from "../components/helpers";

import app from "../components/app";

import JSONEditor from "../components/jsonEditor";




let timeOut = null;

function beautifyJson(jsonString) {
    try {
        // Parse the JSON string to an object
        var jsonObject = JSON.parse(jsonString);

        // Convert the object back to a formatted JSON string with indentation of 2 spaces
        var beautifiedJsonString = JSON.stringify(jsonObject, null, 4);

        // Return the beautified JSON string
        return beautifiedJsonString;
    } catch (error) {
        // Handle any errors that occurred during parsing or formatting
        console.error("Error beautifying JSON: " + error);
        return null; // or handle the error in a way that makes sense for your application
    }
}

export const addNewProperty = function(data) {
    console.log("coming")
    if (typeof data === 'object' && data !== null) {
        if(data.elements){
            for(var k in data.elements) {
                // if(data.elements[k].viewType === "button"){
                    // console.log("pagee- addNewProperty", data["properties"])
                    // data["properties"].overlayColor = "";
                    // data["properties"].margin = "0,0,0,0";
                    // data["properties"].marginWeb = "0,0,0,0";
                    //overlayColor
                //}
                if(data.elements[k]["items"]) {  
                    data.elements[k]["items"].forEach(function(val){
                        for(var key in val) {
                            // if(key === "banner") {
                            //     val[key]["properties"]["target"] = false;
                            // }
                            // if(key === "footerHeading") {
                            //     val[key]["properties"]["background"] = "#00000000";
                            // }
                            if(val[key].viewType === "button"){
                               // val[key]["properties"]["target"] = false;
                                //console.log("val", val[key]["properties"]);
                            //     val["properties"].margin = "0,0,0,0";
                            //     val["properties"].marginWeb = "0,0,0,0";
                                // val[key]["properties"].textColor = "#000000";
                             }
                            // if(val[key].viewType === "socialLinks"){
                            //     console.log("soocial", val[key]["properties"])
                            //     val[key]["properties"].margin = "0,0,0,0";
                            //     val[key]["properties"].marginWeb = "0,0,0,0";
                            // }
                            // if(val[key].viewType === "text" && val[key].editorTitle === "Heading"){
                            //                     console.log("text---nnn", val[key])
                            //                     // val[key]["properties"].margin = "0,0,0,0";
                            //                     // val[key]["properties"].marginWeb = "0,0,0,0";
                            //                 }
                             
                        }

                    })
                }
                 
            }
        }  
    }
    // if (typeof data === 'object' && data !== null) {
    //     if(data.elements){
    //         for(var k in data.elements) {  
    //             if(data.elements[k]) {
    //                 if(data.elements[k]["items"]) {  
    //                     data.elements[k]["items"].forEach(function(val){
    //                         for(var key in val) {
    //                             // console.log("val", val["properties"])
                                
    //                             if(val[key].viewType === "text"){
    //                     console.log("aaaaaaa---", val[key]["properties"])
    //                                 // val[key]["properties"].background = "#00000000"
    //                                 //  val[key]["properties"].overlayColor = ""
    //                                 //  val[key]["properties"].textColor = "#000000" 
    //                             } 
    //                             if(val[key].viewType === "textHtml"){
    //                                 console.log("items.viewType", val[key].viewType)
    //                                 //  val[key]["properties"].background = "#00000000"
    //                                 //  val[key]["properties"].overlayColor = ""
    //                                 //  val[key]["properties"].textColor = "#000000" 
    //                             }
                                
    //                         }
    
    //                     })
    //                 }


    //                 // if(data.elements[k].viewType == "textHtml"){
    //                 //     console.log("coming in sidee 2")
    //                 //     //  if(data.elements[k]["properties"].background == undefined){
    //                 //     //     console.log("coming in sidee")
    //                 //     //     data.elements[k]["properties"].background = "#00000000"
    //                 //     //     data.elements[k]["properties"].backgroundType = "color"
    //                 //     //     // data.elements[k]["properties"].ratioWeb = data.elements[k]["properties"].ratio;
    //                 //     //     // data.elements[k]["properties"].scaleTypeWeb = data.elements[k]["properties"].scaleType;  
    //                 //     //  }  
    //                 // } 
    //             }
    //         }
    //         // for(var k in data.elements) {
    //         //     if(data.elements[k]["properties"]["show"] !== "" && data.elements[k]["properties"].showWeb === undefined){
    //         //         data.elements[k]["properties"].showWeb = data.elements[k]["properties"]["show"];
    //         //     } 

    //         //     if(data.elements[k]["items"]) {  
    //         //         data.elements[k]["items"].forEach(function(val){
    //         //             for(var key in val) {
    //         //                 // console.log("val", val["properties"])
    //         //                 if(val[key].viewType === "image"){
    //         //                     // if(val[key]["properties"].ratio && val[key]["properties"].ratioWeb === undefined && ){
    //         //                     if(val[key]["properties"].ratio == ""){
    //         //                         val[key]["properties"].ratio = "1x1"
    //         //                        val[key]["properties"].ratioWeb = val[key]["properties"].ratio;
    //         //                        val[key]["properties"].scaleTypeWeb = val[key]["properties"].scaleType;
    //         //                     //    val[key]["properties"].overlayColor = "";
    //         //                     //    val[key]["properties"].borderColor = "";
    //         //                        val[key]["properties"].showWeb = val[key]["properties"].show;
    //         //                     } 
    //         //                 }
    //         //                 // if(val[key].viewType === "text"){
    //         //                 //     console.log("items.viewType", val[key].viewType)
    //         //                 // } 
    //         //                 // if(val[key].viewType === "textHtml"){
    //         //                 //     console.log("items.viewType", val[key].viewType)
    //         //                 // }
    //         //                 else{
    //         //                     if(val[key]["properties"]){ 
    //         //                         // if(val[key]["properties"].overlayColor){
    //         //                         //     val[key]["properties"].overlayColor = ""
    //         //                         // } 
    //         //                         if(val[key]["properties"].show !== "" && val[key]["properties"].showWeb === undefined){
    //         //                            val[key]["properties"].showWeb = val[key]["properties"].show;
    //         //                         } 
    //         //                     }else{
    //         //                         // if(val["properties"]){
    //         //                         //     val["properties"].overlayColor = "";
    //         //                         //     val["properties"].borderColor = ""; 
    //         //                         // }
    //         //                     } 
    //         //                 }
    //         //             }

    //         //         })
    //         //     }
    //         //     else if(data.elements[k]) {
    //         //         if(data.elements[k].viewType === "image"){
    //         //            // if(data.elements[k]["properties"].ratio && data.elements[k]["properties"].ratioWeb === undefined){
    //         //             if(data.elements[k]["properties"].ratio == ""){
    //         //                 data.elements[k]["properties"].ratio = "1x1"
    //         //                 data.elements[k]["properties"].ratioWeb = data.elements[k]["properties"].ratio;
    //         //                 data.elements[k]["properties"].scaleTypeWeb = data.elements[k]["properties"].scaleType; 
    //         //                 // data.elements[k]["properties"].overlayColor = "";
    //         //                 // data.elements[k]["properties"].borderColor = ""
    //         //              }  
    //         //         }
    //         //         else{ 
    //         //             // if(data.elements[k]["properties"].overlayColor !== ""){
    //         //             //     data.elements[k]["properties"].overlayColor = ""
    //         //             // } 
    //         //         } 
    //         //     }
    //         // }
    //     }  
    // }
    return data;
}


export default class Pages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data:[],
            item:{
                title:"",
                data:{}
            }
        }
        // this.updateData = this.updateData.bind(this);
        // this.clickElement = this.clickElement.bind(this);
        // this.actionClick = this.actionClick.bind(this);
        // this.loadIframe = this.loadIframe.bind(this);
        // this.renderPage = this.renderPage.bind(this);
        this.loadData = this.loadData.bind(this);
        this.saveItem = this.saveItem.bind(this);
        this.updateItem = this.updateItem.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
    }
    componentWillMount() {
        this.loadData(this.props);
    }
    componentWillReceiveProps(props) {
        this.loadData(props);
    }
   
    loadData(props) {
        const self = this;
        if(props.category) {
            if(props.category === "add") {
                self.setState({
                    category:props.category
                })
            }
            else {
                app.fetchPost({
                    "method":"getAllMaster",
                }).then(function(response){
                    let itemData = null;
                    if(response.data) {
                        response.data.forEach(function(v){
                            if(v.id === props.category) {
                                itemData = JSON.parse(JSON.stringify(v))
                            }
                        });
                        
                        if(itemData) {
                            
                            // itemData["data"] = self.addNewProperty(JSON.parse(itemData["data"]));
                            itemData["data"] = JSON.parse(itemData["data"]);
                            // console.log("itemData", itemData)
                            self.setState({
                                item:itemData,
                                category:props.category
                            })
                        }
                    }
                })
            }
        }
        else {
            app.fetchPost({
                "method":"getAllMaster"
            }).then(function(response){
                if(response.data) {
                    self.setState({
                        data:response.data,
                        category:null
                    })
                }
            })
        }
    }
    updateItem(key, value) {
        let itemData = JSON.parse(JSON.stringify(this.state.item));
        itemData[key] = value;
        this.setState({
            item:itemData
        })
    }

    saveItem() {
        const item = this.state.item;
        app.fetchPost({
            "method":"saveMasterBlock",
            "id":item.id,
            "title":item.title,
            "data":JSON.stringify(item.data)
        }).then(function(response){
            if(!item.id) {
                if(response.data._id) {
                    window.pushState("master-blocks");
                }
            }
        })
    }
    deleteItem(index) {
        const self = this;
        const {data} = self.state;
        if(window.confirm("do you really want to delete this Master")) {
            app.fetchPost({
                "method":"deleteMaster",
                "id":data[index].id
            }).then(function(){
                self.setState({
                    data:data.filter(function(v, i){
                        if(i === index) {
                            return false;
                        }
                        return true;
                    })
                })
            })
        }
    }

    addNewProperty(data) {
        console.log("data---", data.properties)
        if (typeof data === 'object' && data !== null) {
            if(data.elements){
                for(var k in data.elements) {
                    // console.log("gridItem---jjj", data.elements[k]["properties"]["show"])
                    // if(data.elements[k]["properties"]["show"] !== "" && data.elements[k]["properties"].showWeb === undefined){
                    //     data.elements[k]["properties"].showWeb = data.elements[k]["properties"]["show"];
                    // } 
                    // console.log("rrooot", data.elements[k].viewType === "button")
                    if(data.elements[k].viewType === "button"){
                        console.log("but", data["properties"])
                        data["properties"].margin = "0,0,0,0";
                        data["properties"].marginWeb = "0,0,0,0";
                    }
                    if(data.elements[k]["items"]) {  
                        data.elements[k]["items"].forEach(function(val){
                            for(var key in val) {
                                if(val[key].viewType === "button"){
                                    console.log("val", val["properties"]);
                                    val["properties"].margin = "0,0,0,0";
                                    val["properties"].marginWeb = "0,0,0,0";
                                    val["properties"].itemAlignment = "center";
                                }
                                if(val[key].viewType === "socialLinks"){
                                    console.log("soocial", val[key]["properties"])
                                    val[key]["properties"].margin = "0,0,0,0";
                                    val[key]["properties"].marginWeb = "0,0,0,0";
                                }
                                // if(val[key].viewType === "image"){
                                //     if(val[key]["properties"].ratio && val[key]["properties"].ratioWeb === undefined){
                                //        val[key]["properties"].ratioWeb = val[key]["properties"].ratio;
                                //        val[key]["properties"].scaleTypeWeb = val[key]["properties"].scaleType;
                                //        val[key]["properties"].overlayColor = "";
                                //        val[key]["properties"].borderColor = "";
                                //        val[key]["properties"].showWeb = val[key]["properties"].show;
                                //     } 
                                // }
                                // if(val[key].viewType === "text"){
                                //     console.log("items.viewType", val[key].viewType)
                                // } 
                                // if(val[key].viewType === "textHtml"){
                                //     console.log("items.viewType", val[key].viewType)
                                // }
                              //  else{
                                    // if(val[key]["properties"]){ 
                                    //     if(val[key]["properties"].overlayColor){
                                    //         val[key]["properties"].overlayColor = ""
                                    //     } 
                                    //     if(val[key]["properties"].show !== "" && val[key]["properties"].showWeb === undefined){
                                    //        val[key]["properties"].showWeb = val[key]["properties"].show;
                                    //     } 
                                    // }else{
                                    //     if(val["properties"]){
                                    //         val["properties"].overlayColor = "";
                                    //         val["properties"].borderColor = ""; 
                                    //     }
                                    // } 
                              //  }
                            }
    
                        })
                    }
                    else if(data.elements[k]) {
                        // console.log("rrooot", data.elements[k]["properties"])
                        // if(data.elements[k]["properties"].overlayColor !== ""){
                        //     data.elements[k]["properties"].overlayColor = ""
                        // } 
                        // console.log("gridItem-ccc", data.elements[k]["properties"]["show"])
                        // if(data.elements[k].viewType === "image"){
                        //     if(data.elements[k]["properties"].ratio && data.elements[k]["properties"].ratioWeb === undefined){
                        //         data.elements[k]["properties"].ratioWeb = data.elements[k]["properties"].ratio;
                        //         data.elements[k]["properties"].scaleTypeWeb = data.elements[k]["properties"].scaleType; 
                        //         data.elements[k]["properties"].overlayColor = "";
                        //         data.elements[k]["properties"].borderColor = ""
                        //      }  
                        // }
                        // else{ 
                        //     if(data.elements[k]["properties"].overlayColor !== ""){
                        //         data.elements[k]["properties"].overlayColor = ""
                        //     } 
                        // } 
                    }
                }
            }  
        }
        return data;
    }
    

    render() {
        const self = this;
        const {data, item, category} = self.state;
        let html = "";
    const button =   <div className="w-100 pt-3">
    <a  className="btn btn-lg btn-outline-success" href={`/master-blocks/add`}>Add Master Block</a>
    </div>
    if(category) {
        if(category === "add") {
            html = <div className="container-fluid p-2 w-100 h-100">
            <div className="w-100 d-flex p-1" style={{height:"50px"}}>
            <input type="text" id="title" className="form-control" placeholder="Disabled input" onInput={function(e){
              //  console.log(e.currentTarget.value);
                self.updateItem("title", e.currentTarget.value);
            }} />
            <button className="btn btn-success" onClick={self.saveItem}>{app.getLang("save")}</button>
            </div>
            <div className="w-100 beautify-json" style={{height:"calc(100% - 50px)"}}>
                   
            <JSONEditor text={beautifyJson(JSON.stringify({}))} callback={function(text){
                     try {
                        JSON.parse(text);
                        self.updateItem("data", JSON.parse(text));
                        console.log("json is validated")
                    } catch (error) {
                        console.error("not valid json")
                    }
                }} />
                </div>
            </div>
        }
        else {
            if(item) {
                html = <div className="container-fluid p-2 w-100 h-100">
                <div className="w-100 d-flex p-1" style={{height:"50px"}}>
                <input type="text" id="title" className="form-control" value={item.title} placeholder="Disabled input" onChange={function(e){
                    self.updateItem("title", e.currentTarget.value);
                }} />
                <button className="btn btn-success" data-id={item.id} onClick={self.saveItem}>{app.getLang("save")}</button> 
                </div>
                <div className="w-100 beautify-json" style={{height:"calc(100% - 50px)"}}>
                <JSONEditor text={beautifyJson(JSON.stringify(item.data))} callback={function(text){
                     try {
                        JSON.parse(text);
                        self.updateItem("data", JSON.parse(text));
                        console.log("json is validated")
                    } catch (error) {
                        console.error("not valid json")
                    }
                }} />
                </div>
                </div>
            }
            else {
                html = <div>Not Found</div>
            }
        }
        
    }
    else {
        if(data.length) {
            html = <div className="container p-2">
            <ul className="list-group">
                {
                    data.map(function(v, i){
                        return <li className="list-group-item d-flex" key={`master-${i}`}>
                            <span>{v.title}</span>
                            <div className="ms-auto">
                                <a href={`/master-blocks/${v.id}`} className="btn btn-sm btn-secondary ms-2">Edit</a>
                                <button type="button" className="btn btn-sm btn-danger ms-2 d-none" onClick={() => self.deleteItem(i)}>Delete</button>
                            </div>
                        </li>
                    })
                }
            </ul>
            {button}
            </div>
        }
        else {
            html = <div className="container p-2 text-cnter">
              {button}
            </div>
        }
       
        }
        return <AppWrapper>
        {html}
        </AppWrapper>
    }
}
